import { immerable } from "immer";
import { filtersTypeEnum } from "@sttedra_ui/framework";

import { tableViews, useSmallAddLabel } from "@/composables/_commons/helper.js";
import { categoriesList } from "@/api/categories/categories.api.js";

export default class CategoriesTableConfig {
  [immerable] = true;

  constructor(buildModal, deleteRegister) {
    const fields = [
      {
        field: "titulo",
        label: "Nombre",
      },
      {
        field: "descripcion",
        label: "Descripción",
      },
      {
        field: "creadaPor",
        label: "Usuario",
      },
      {
        field: "numeroInformesAsociados",
        label: "Nº Informes",
        sortable: false,
      },
      {
        field: "fechaCreacion",
        label: "Fecha de creación",
      },
    ];

    const advancedFilters = [
      {
        field: "titulo",
        label: "Nombre",
      },
      {
        field: "descripcion",
        label: "Descripción",
      },
      {
        field: "creadaPor",
        label: "Usuario",
      },
      {
        field: "fechaCreacion",
        label: "Fecha de creación",
      },
    ];

    return {
      title: "Categorías",
      api: categoriesList,
      schema: fields,
      actions: {
        header: [
          {
            label: useSmallAddLabel() ? "Añadir" : "Añadir categoría",
            icon: "add",
            command: () => buildModal(),
            extended: true,
          },
        ],
        item: [
          {
            label: "Editar",
            icon: "edit",
            command: (event) => buildModal(event),
            extended: false,
          },
          {
            label: "Borrar",
            icon: "delete",
            command: (event) => deleteRegister(event),
            extended: false,
            classObj: ["delete-action"],
            disabled: (event) => event.orden === 0,
          },
        ],
      },
      filters: [
        {
          type: filtersTypeEnum.GLOBAL,
          fields: advancedFilters,
        },
        {
          type: filtersTypeEnum.ADVANCED,
          fields: advancedFilters,
        },
      ],
      views: tableViews(),
    };
  }
}
